import axios from './axios';
import { handleApiError } from './apiErrorHandler';

export default {

    getJobs: async () => {
        try {

            const response = await axios.get('/data-operations');

            return {
                success: true,
                data: response.data
            };

        } catch (error) {
            return handleApiError(error);
        }
    },

    executeJob: async (jobName, payload = {}) => {
        try {

            const response = await axios.post(
                `/data-operations/${jobName}`,
                payload
            );

            return {
                success: true,
                data: response.data
            };

        } catch (error) {
            return handleApiError(error);
        }
    }
};